export default {
  seasonsList(state) {
    return state.seasonsList;
  },
  currentSeason(state) {
    return state.currentSeason;
  },
}